<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    scrim="rgba(15, 23, 32, 0.55)"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card class="lms-confirm-dialog">
      <v-card-title class="lms-confirm-dialog__title">{{ title }}</v-card-title>
      <v-card-text class="lms-confirm-dialog__body">{{ message }}</v-card-text>
      <v-card-actions>
        <v-btn variant="text" :disabled="loading" @click="$emit('update:modelValue', false)">
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          :color="tone === 'danger' ? 'error' : 'primary'"
          variant="flat"
          :loading="loading"
          @click="$emit('confirm')"
        >
          {{ confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: 'Confirm' },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirm' },
  tone: { type: String, default: 'primary' },
  loading: { type: Boolean, default: false }
})
defineEmits(['update:modelValue', 'confirm'])
</script>

<style scoped>
.lms-confirm-dialog {
  border-radius: 16px !important;
}
.lms-confirm-dialog__title {
  font-family: Outfit, 'Source Sans 3', sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.lms-confirm-dialog__body {
  color: var(--lms-text-secondary);
}
</style>
